import InputField from "@/components/InputField";
import defaultValues from "@/constant/defaultValues";
import { isEmpty } from "lodash";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";

const RoadFreight = (props) => {
  const { TERM_LIST, ROAD_TYPE } = defaultValues;

  const {
    errors,
    styleError,
    formData,
    handleFocusOut,
    handleChange,
    handleCountryFromChange,
    handleCountryToChange,
    handleTermChange,
    showPickupAddress,
    showDeliveryAddress,
    countries,
    selectedTerm,
    selectedCountryFrom,
    selectedCountryTo,
    handlePortOfOriginChange,
    handleOriginPortInputChange,
    portOfOriginList,
    selectedPortOfOrigin,
    validatePortInput,
    originLoader,
    selectedOceanType,
    handleOceanTypeChange,
    destinationLoader,
    handlePortOfDestinationChange,
    handleDestinationPortInputChange,
    portOfDestinationList,
    selectedPortOfDestination,
  } = props;

  return (
    <>
      <div className="col-sm-6">
        <div className="input-group">
          <label className="form-label required">Cargo Type</label>
          <div className="input-pad">
            <Select
              name="ocean_type"
              options={ROAD_TYPE}
              value={selectedOceanType}
              onChange={handleOceanTypeChange}
              placeholder="Select cargo type"
              className="dd-pad"
              noOptionsMessage={() => "No Ocean Type Found"}
              onBlur={handleFocusOut}
            />
            {errors.ocean_type && (
              <span className="company-required" style={styleError}>
                {errors.ocean_type}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="col-sm-6 ">
        <div className="input-group">
          <label className="form-label">Origin Country</label>
          <div className="input-pad">
            <Select
              name="country_from"
              options={countries}
              value={selectedCountryFrom}
              onChange={handleCountryFromChange}
              placeholder="Select origin country"
              className="dd-pad"
              onBlur={handleFocusOut}
              noOptionsMessage={() => "No Country Found"}
            />
            {errors.country_from && (
              <span className="company-required" style={styleError}>
                {errors.country_from}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="col-sm-6">
        <div className="input-group">
          <label className="form-label">Port of origin</label>
          <div className="input-pad">
            <InputField
              type="text"
              name="port_of_origin"
              value={formData.port_of_origin}
              autoComplete="off"
              placeholder={`Enter origin port`}
              onChange={handleChange}
              onBlur={handleFocusOut}
            />

            {errors.port_of_origin && (
              <span className="company-required" style={styleError}>
                {errors.port_of_origin}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="col-sm-6 ">
        <div className="input-group">
          <label className="form-label">Destination Country</label>
          <div className="input-pad">
            <Select
              name="country_to"
              options={countries}
              value={selectedCountryTo}
              onChange={handleCountryToChange}
              placeholder="Select destination country"
              className="dd-pad"
              noOptionsMessage={() => "No Country Found"}
              onBlur={handleFocusOut}
            />
            {errors.country_to && (
              <span className="company-required" style={styleError}>
                {errors.country_to}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="col-sm-6 ">
        <div className="input-group">
          <label className="form-label">Port of destination</label>
          <div className="input-pad">
            <InputField
              type="text"
              name="port_of_destination"
              value={formData.port_of_destination}
              autoComplete="off"
              placeholder={`Enter destination port`}
              onChange={handleChange}
              onBlur={handleFocusOut}
            />

            {errors.port_of_destination && (
              <span className="company-required" style={styleError}>
                {errors.port_of_destination}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="col-sm-6 ">
        <div className="input-group">
          <label className="form-label required">Commodity</label>
          <div className="input-pad">
            <InputField
              type="text"
              name="commodity"
              value={formData.commodity}
              // className="form-control"
              autoComplete="off"
              placeholder="Enter commodity"
              onChange={handleChange}
              onBlur={handleFocusOut}
            />
            {errors.commodity && (
              <span className="company-required" style={styleError}>
                {errors.commodity}
              </span>
            )}
          </div>
        </div>
      </div>

      <div className="col-sm-6 ">
        <div className="input-group">
          <label className="form-label">HS Code</label>
          <div className="input-pad">
            <InputField
              type="text"
              name="hs_code"
              value={formData.hs_code}
              // className="form-control"
              autoComplete="off"
              placeholder="Enter hs code"
              onChange={handleChange}
              onBlur={handleFocusOut}
            />
            {errors.hs_code && (
              <span className="company-required" style={styleError}>
                {errors.hs_code}
              </span>
            )}
          </div>
        </div>
      </div>

      <div className="col-sm-6 ">
        <div className="input-group">
          <label className="form-label required">
            No of Containers / Vehicles
          </label>
          <div className="input-pad">
            <InputField
              type="text"
              name="no_of_containers"
              value={formData.no_of_containers}
              // className="form-control"
              autoComplete="off"
              placeholder="Enter No of Containers / Vehicles"
              onChange={handleChange}
              onBlur={handleFocusOut}
            />
            {errors.no_of_containers && (
              <span className="company-required" style={styleError}>
                {errors.no_of_containers}
              </span>
            )}
          </div>
        </div>
      </div>

      <div className="col-sm-6 ">
        <div className="input-group">
          <label className="form-label required">
            Containers Type/Boxes/Pallat/Packages
          </label>
          <div className="input-pad">
            <InputField
              type="text"
              name="cbpp"
              value={formData.cbpp}
              // className="form-control"
              autoComplete="off"
              placeholder="Enter containers Type/Boxes/Pallat/Packages"
              onChange={handleChange}
              onBlur={handleFocusOut}
            />
            {errors.cbpp && (
              <span className="company-required" style={styleError}>
                {errors.cbpp}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="col-sm-6 ">
        <div className="input-group">
          <label className="form-label">Total Weight (KG)</label>
          <div className="input-pad">
            <InputField
              type="text"
              name="total_weight"
              value={formData.total_weight}
              // className="form-control"
              autoComplete="off"
              placeholder="Enter Total Weight (KG)"
              onChange={handleChange}
              onBlur={handleFocusOut}
            />

            {errors.total_weight && (
              <span className="company-required" style={styleError}>
                {errors.total_weight}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="col-sm-6 ">
        <div className="input-group">
          <label className="form-label">Term</label>
          <div className="input-pad">
            <Select
              name="term"
              options={TERM_LIST}
              value={selectedTerm}
              onChange={handleTermChange}
              placeholder="Select ocean type"
              className="dd-pad"
              noOptionsMessage={() => "No Term Found"}
              onBlur={handleFocusOut}
            />

            {errors.term && (
              <span className="company-required" style={styleError}>
                {errors.term}
              </span>
            )}
          </div>
        </div>
      </div>

      {selectedTerm &&
        !isEmpty(selectedTerm) &&
        showPickupAddress.includes(selectedTerm.value) && (
          <div className="col-sm-6 ">
            <div className="input-group">
              <label className="form-label required">Pickup Address</label>
              <div className="input-pad">
                <InputField
                  type="text"
                  name="pickup_address"
                  value={formData.pickup_address}
                  // className="form-control"
                  autoComplete="off"
                  placeholder="Enter pickup address"
                  onChange={handleChange}
                  onBlur={handleFocusOut}
                />
                {errors.pickup_address && (
                  <span className="company-required" style={styleError}>
                    {errors.pickup_address}
                  </span>
                )}
              </div>
            </div>
          </div>
        )}

      {selectedTerm &&
        !isEmpty(selectedTerm) &&
        showDeliveryAddress.includes(selectedTerm.value) && (
          <div className="col-sm-6 ">
            <div className="input-group">
              <label className="form-label required">Delivery Address</label>
              <div className="input-pad">
                <InputField
                  type="text"
                  name="delivery_address"
                  value={formData.delivery_address}
                  // className="form-control"
                  autoComplete="off"
                  placeholder="Enter delivery address"
                  onChange={handleChange}
                  onBlur={handleFocusOut}
                />
                {errors.delivery_address && (
                  <span className="company-required" style={styleError}>
                    {errors.delivery_address}
                  </span>
                )}
              </div>
            </div>
          </div>
        )}
    </>
  );
};

export default RoadFreight;
